import React from 'react';
import CloseIcon from 'Assets/Icons/close.svg';
import { useRestrictModalNavigation } from './hooks/useRestrictModalNavigation';
import * as Styles from './styles';
import { useAppBarUpdate } from '@/hooks/useAppBarUpdate';
import {
    LIGHT_THEME_APPBAR_CONFIG,
    POPUPS_APPBAR_CONFIG,
} from 'config/appbarConfig';
import { getLastPageAppBarConfig } from '@/utils/webviewHandlers';

interface IMobileDrawerProps {
    show: boolean;
    title?: string;
    hideClose?: boolean;
    className?: string;
    onClose?: () => void;
    children: React.ReactElement | React.ReactElement[];
}

const MobileDrawer: React.FC<IMobileDrawerProps> = ({
    show,
    title,
    hideClose,
    children,
    className,
    onClose,
}) => {
    const modalAppConfig = show
        ? POPUPS_APPBAR_CONFIG
        : getLastPageAppBarConfig() || LIGHT_THEME_APPBAR_CONFIG;

    useAppBarUpdate(modalAppConfig, true, false);

    return (
        <Styles.Drawer
            className={className}
            anchor="bottom"
            open={show}
            onClose={onClose}
        >
            {!hideClose && (
                <Styles.IconWrapper onClick={onClose} id="close-button">
                    <CloseIcon />
                </Styles.IconWrapper>
            )}
            {title && <Styles.Heading variant="h5">{title}</Styles.Heading>}
            {children}
        </Styles.Drawer>
    );
};

export default MobileDrawer;
